import { capitalize, Chip, type ChipProps } from "@mui/material";

export type ContractStatus = "active" | "inactive" | "canceled" | "expired" | "terminated";

type StatusChipConfig = {
  color: ChipProps["color"];
  label: string;
};

const statusConfig: Record<ContractStatus, StatusChipConfig> = {
  active: {
    color: "success",
    label: "Active",
  },
  inactive: {
    color: "default",
    label: "Inactive",
  },
  canceled: {
    color: "info",
    label: "Canceled",
  },
  expired: {
    color: "warning",
    label: "Expired",
  },
  terminated: {
    color: "error",
    label: "Terminated",
  },
};

const getStatusChip = (status: string): StatusChipConfig =>
  statusConfig[status as ContractStatus] ?? {
    color: "default",
    label: capitalize(status),
  };

type Props = {
  status: ContractStatus | string;
};

export const StatusChip = ({ status }: Props) => {
  const { color, label } = getStatusChip(status);
  return <Chip variant="status" color={color} label={label} data-cy={`contract-status-chip-${status}`} />;
};
